<!-- src/views/weCom/Chat.vue -->
<template>
  <div class="p_chat">
    <iframe id="ifm" :src="'https://jobai.joball.net/chatbot/' + data" style="width: 100%; height: 99vh; min-height: 700px" frameborder="0" allow="microphone"></iframe>
  </div>
</template>

<script>
  export default {
    name: 'Chat',
    data() {
      return {
        data: '',
      }
    },
    async created() {
      this.$store.commit("setHiddenLeft", true);
      if (this.$route.query.data != undefined && this.$route.query.data) {
        this.data = this.$route.query.data;
        document.title = this.$route.query.title;
      }
    },
  }
</script>

<style scoped>
</style>
<style>
</style>